import { AfterViewChecked, Component, Input, OnInit, ViewChild } from '@angular/core';
import { TableColumn } from '../table/models/table-structure.model';
import {
  MatTable,
  MatTableDataSource,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { ExpandableRowGroup, ExpansionContent } from './expandable-row.model';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-expandable-row-table',
  templateUrl: './expandable-row-table.component.html',
  styleUrls: ['./expandable-row-table.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    NgStyle,
    MatCellDef,
    MatCell,
    NgTemplateOutlet,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatIcon,
    MatTooltip,
    TranslateModule
  ]
})
export class ExpandableRowTableComponent implements OnInit, AfterViewChecked {
  @Input() data: ExpandableRowGroup[];
  @Input() columns: TableColumn[];

  dataSource: MatTableDataSource<ExpandableRowGroup | ExpansionContent>;
  displayedColumns: string[];
  expandedRowGroup: ExpandableRowGroup;

  @ViewChild(MatTable, { static: false })
  private table: MatTable<ExpandableRowGroup>;

  ngAfterViewChecked(): void {
    if (this.table) {
      this.table.updateStickyColumnStyles();
    }
  }

  get hidden() {
    return !this.data || !this.columns;
  }

  isExpansionContentRow = (i: number, row: Object) => {
    return row.hasOwnProperty('expanded');
  };

  isExpandableRowGroup = (i: number, row: Object) => {
    return !this.isExpansionContentRow(i, row);
  };

  ngOnInit(): void {
    if (!this.hidden) {
      this.updateDataSource();
      this.displayedColumns = this.columns.map(c => c.name);
    }
  }

  getDynamicFlexStylingFor(ix: number) {
    const flexValue = `1 1 ${this.getFlexStyling(ix)}`;

    return {
      flex: flexValue,
      maxWidth: this.getFlexStyling(ix),
      minWidth: this.getFlexStyling(ix),
      boxSizing: 'border-box'
    };
  }

  private getFlexStyling(cellIndex: number) {
    // Hardcoded for qa-results.component
    switch (cellIndex) {
      case 4: {
        return '150px';
      }
      case 1: {
        return '260px';
      }
      default: {
        return '200px';
      }
    }
  }

  isExpandedRowGroup(rowGroup: ExpandableRowGroup) {
    return rowGroup && rowGroup.expansionContent?.expanded && rowGroup.expansionContent?.rows?.length > 0;
  }

  isExpandedContent(expansionContent: ExpansionContent) {
    return expansionContent && expansionContent.expanded && expansionContent.rows?.length > 0;
  }

  private updateDataSource() {
    const flatData = [];
    this.data.forEach(d => flatData.push(d, d.expansionContent));
    this.dataSource = new MatTableDataSource(flatData);
  }

  renderRows(updatedData: ExpandableRowGroup[]) {
    this.data = updatedData;
    this.updateDataSource();
    this.table.renderRows();
  }
}
